import React from "react";

/**
 * BrandLogo
 * - Looks good on dark cards.
 * - Click opens threadlock.ai (external, safe).
 * - If /brand/threadlock-logo.svg exists in /public, it will be used.
 * - Otherwise falls back to an icon + wordmark that matches the UI.
 */
const BrandLogo = ({ className = "" }) => {
  // Try to use a public asset if it exists (no build import needed with Vite).
  const publicLogoPath = "/brand/threadlock-logo.svg"; // put file here if/when available

  return (
    <a
      href="https://threadlock.ai"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="ThreadLock — visit threadlock.ai"
      className={`group inline-flex items-center gap-2 text-white/90 hover:text-white transition-colors ${className}`}
      title="ThreadLock"
    >
      {/* Prefer external SVG if present; otherwise render fallback mark */}
      <picture className="inline-flex items-center">
        {/* If the asset isn’t there, the <img> fails silently; we still render the fallback icon below */}
        <img
          src={publicLogoPath}
          alt=""
          onError={(e) => (e.currentTarget.style.display = "none")}
          className="h-5 w-auto select-none"
          decoding="async"
          loading="eager"
        />
        {/* Fallback mark (small document/lock-ish glyph in brand accent) */}
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          className="h-5 w-5 -ml-5 img-[hidden]:ml-0 text-[var(--tl-accent,#f97316)]"
        >
          <path
            d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            points="14 2 14 8 20 8"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </picture>

      {/* Wordmark that harmonizes with your UI */}
      <span className="font-semibold tracking-tight leading-none">
        Thread<span className="text-[var(--tl-accent,#f97316)]">Lock</span>
      </span>
    </a>
  );
};

export default BrandLogo;
